
import { z } from "zod";

export const FundingPaymentMethodValues = ["LOAN", "UP_FRONT"] as const;
export const FundingPaymentMethodSchema = z.enum(FundingPaymentMethodValues);
export const FundingPaymentMethod = FundingPaymentMethodSchema.enum;
export type FundingPaymentMethod = (typeof FundingPaymentMethodValues)[number];
export const FundingPaymentMethodDisplayNames = { "LOAN": "Pay over time",
"UP_FRONT": "Pay up front", } satisfies Record<FundingPaymentMethod, string>;
